import React from 'react';
import ShopItemComponent from '../shop-item';

const ShopItem = () => <ShopItemComponent />;

export default ShopItem;
